/**
 * Error logger tenant scope
 *
 * Stores current organization_id and client_id so the error logger can
 * attach them to log entries when not explicitly provided (e.g. from
 * global handlers). Set by TenantContext when tenant changes.
 */

let currentScope: {
  organizationId: string | null;
  clientId: string | null;
} = {
  organizationId: null,
  clientId: null,
};

export function setErrorLoggerScope(
  organizationId: string | null,
  clientId: string | null
): void {
  currentScope = { organizationId, clientId };
}

export function getErrorLoggerScope(): {
  organizationId: string | null;
  clientId: string | null;
} {
  return { ...currentScope };
}
